import { useHotkeySequence } from "@tanstack/react-hotkeys";
import useEventQueueStore from "@/features/tracking/hooks/use-event-queue";
import Logger from "@/lib/logger.ts";
import { loopList } from "@/utils/iterator.ts";

export default function useEventQueue() {
    const eventQueue = useEventQueueStore();

    useHotkeySequence(
        ["Q", "Q"],
        () => {
            if (!Logger.enabled) return;

            if (!eventQueue.length) {
                Logger.success("No pending events!");
                return;
            }

            Logger.warn("Pending events:");
            loopList(eventQueue, (item, index) => console.info(`${index}:`, item));
        },
        { ignoreInputs: true, timeout: 200 },
    );
}
